<template>
  <ConfirmDialog></ConfirmDialog>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >PARAMETROS</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3">VEH&Iacute;CULOS</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <Toast />
    <div
      class="flex align-items-start flex-column lg:justify-content-between lg:flex-row"
    >
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Veh&iacute;culos
          <Badge size="xlarge" severity="success"> {{ totalRegistros }}</Badge>
        </div>
      </div>
      <div class="flex mt-3 lg:mt-0">
        <Button
          v-if="'Vehiculos Crear' in auth.user.permissions"
          label="NUEVO"
          v-tooltip.top="'Nuevo Vehículo'"
          icon="pi pi-plus"
          class="p-button-outlined mr-2 p-button-lg"
          @click="openNuevo"
        />
      </div>
    </div>
    <div class="mt-4">
      <DataTable
        ref="dt_vehiculos"
        :value="vehiculos"
        :loading="cargando"
        dataKey="id"
        :paginator="true"
        :rows="10"
        :rowHover="true"
        :filters="buscar"
        class="p-datatable-sm"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 50, 100]"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Vehiculos"
        responsiveLayout="scroll"
        selectionMode="single click"
        @row-dblclick="editVehiculo($event.data)"
      >
        <template #header>
          <div
            class="flex flex-column md:flex-row md:justify-content-end md:align-items-end"
          >
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="buscar['global'].value"
                placeholder="Buscar Vehículo"
              />
            </span>
          </div>
        </template>

        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>
        <template #empty>
          <span class="flex align-items-center justify-content-center p-invalid"
            >No existen Registros!</span
          ></template
        >
        <Column header="#">
          <template #body="slotProps">
            {{ 1 + slotProps.index }}
          </template>
        </Column>
        <Column field="nombre_cliente" header="CLIENTE"></Column>
        <Column field="tamanio" header="TAMANIO">
          <template #body="{ data }">
            {{ tamanios[data.tamanio - 1].label }}
          </template>
        </Column>
        <Column field="placa" header="PLACA"></Column>
        <Column field="marca_texto" header="MARCA"></Column>
        <Column field="modelo_texto" header="MODELO"></Column>
        <Column field="color" header="COLOR"></Column>
        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <span :class="'product-badge ' + claseEstado[data.estado]">
              {{ data.estado_texto }}
            </span>
          </template>
        </Column>
        <Column header="ACCIONES">
          <template #body="slotProps">
            <Button
              class="p-button-icon-only p-button-raised"
              v-tooltip.top="'Ver Acciones'"
              icon="pi pi-ellipsis-v"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu
              :ref="'menu' + slotProps.data.id"
              :popup="true"
              :model="acciones(slotProps.data)"
            >
            </Menu>
          </template>
        </Column>
      </DataTable>
    </div>
    <VehiculoCreate
      :show="vehiculoDialog"
      :vehiculo="vehiculo"
      @closeModalVehiculo="ocultarDialog"
      @actualizarListadoVehiculo="cargarVehiculos"
    >
    </VehiculoCreate>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import VehiculoService from "@/service/VehiculoService";
import { useAuth } from "@/stores";
import VehiculoCreate from "@/module/vehiculos/VehiculoCreate.vue";

export default {
  components: {
    VehiculoCreate,
  },
  data() {
    return {
      vehiculos: [],
      cargando: true,
      vehiculoDialog: false,
      deleteVehiculoDialog: false,
      vehiculo: {},
      buscar: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      enviado: false,
      estados: [
        { label: "INACTIVO", value: 0 },
        { label: "ACTIVO", value: 1 },
      ],
      errors: {},
      totalRegistros: 0,
      claseEstado: ["status-outofstock", "status-instock"],
      tamanios: [
        { label: "PEQUEÑO", value: 1 },
        { label: "MEDIANO", value: 2 },
        { label: "GRANDE", value: 3 },
        { label: "OTRO", value: 4 },
      ],
    };
  },
  vehiculoService: null,
  auth: null,
  created() {
    this.auth = useAuth();
    this.vehiculoService = new VehiculoService();
  },
  mounted() {
    this.cargarVehiculos();
  },
  methods: {
    acciones(datos) {
      let permisosUsuarioAuth = this.auth.user.permissions;
      return [
        {
          label: "Editar",
          disabled: "Vehiculos Editar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-pencil",
          command: () => {
            this.editVehiculo(datos);
          },
        },
        {
          label: "Eliminar",
          disabled: "Vehiculos Eliminar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-trash",
          command: () => {
            this.deleteVehiculo(datos.id);
          },
        },
      ];
    },
    deleteVehiculo(id) {
      this.$confirm.require({
        message: "¿Está seguro que desea eliminar el vehículo?",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si, deseo eliminar",
        rejectLabel: "No, cancelar",
        accept: () => {
          this.vehiculoService.deleteVehiculo(id).then((response) => {
            if (response.status == 200) {
              this.$toast.add({
                severity: "success",
                summary: "Éxito",
                detail: response.mensaje,
                life: 3000,
              });
              this.cargarVehiculos();
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: response.mensaje,
                life: 3000,
              });
            }
          });
        },
      });
    },
    cargarVehiculos() {
      this.vehiculoService.getVehiculosAll().then((data) => {
        this.vehiculos = data.vehiculos || [];
        this.totalRegistros = this.vehiculos ? this.vehiculos.length : 0;
        this.cargando = false;
      });
    },
    openNuevo() {
      this.vehiculo = {
        estado: { label: "Activo", value: 1 },
      };
      this.enviado = false;
      this.vehiculoDialog = true;
    },
    ocultarDialog() {
      this.vehiculoDialog = false;
      this.enviado = false;
    },
    textoEstado(estado) {
      return estado == 1 ? "ACTIVO" : "INACTIVO";
    },
    editVehiculo(vehiculo) {
      this.vehiculo = {
        ...vehiculo,
        estado: {
          label: this.textoEstado(vehiculo.estado),
          value: vehiculo.estado,
        },
      };
      this.vehiculoDialog = true;

      this.enviado = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
</style>
